var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"box"}},[(_vm.isRouterAlives_)?_c('router-view',{staticStyle:{"min-height":"750px"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }